<template>
  <v-layout column class="batch-form">
    <v-container text-xs-center>
      <h2 class="title">New Mixing Batch</h2>
    </v-container>
    <form>
      <v-container grid-list-md class="padding-top">
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field label="Batch number"
              v-model="form.id"
              @input="$v.form.id.$touch()"
              @blur="$v.form.id.$touch();slugifyId()"
              :error-messages="getFormErrorMessage('id')"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field label="Mixing Time"
              v-model="form.dosing_at"
              @input="$v.form.dosing_at.$touch()"
              @blur="$v.form.dosing_at.$touch()"
              hint="Format YYYY/MM/DD hh:mm:ss"
              mask="####/##/## ##:##:##"
              :return-masked-value="true"
              :error-messages="getFormErrorMessage('dosing_at')"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 v-for="(ingredient, $index) in ingredients" :key="ingredient.id">
            <div class="font-weight-medium">{{ingredient.name}}</div>
            <v-select :items="getLotsForIngredient(ingredient)" item-text="id" item-value="id" label="Supplier Lot Number"
              v-model="form.lots[$index]"
              :return-object="true"
              @input="$v.form.lots.$each.$touch()"
              @blur="$v.form.lots.$each.$touch()"
              :error-messages="getFormErrorMessage('lots', $index)"
            ></v-select>
          </v-flex>

        </v-layout>
      </v-container>
    </form>
    <v-layout row wrap>
      <v-container class="padding-top">
        <v-flex xs12>
          <v-btn @click="validateFormShipment()" raised block large color="primary" :disabled="submit" class="btn">save</v-btn>
        </v-flex>
        <v-flex xs12>
          <v-btn @click="handleClose()" flat block large color="primary" class="btn">cancel</v-btn>
        </v-flex>
      </v-container>
    </v-layout>
  </v-layout>

</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import slugify from '@sindresorhus/slugify'

export default {
  name: 'BatchForm',
  computed: {
    ...mapGetters({
      ingredients: 'ingredients',
      getLotsForIngredient: 'getLotsForIngredient',
      packagingPlant: 'packagingPlant'
    })
  },
  data () {
    return {
      submit: false,
      form: {
        location: '',
        id: '',
        dosing_at: '',
        lots: [{}, {}]
      }
    }
  },
  validations () {
    return {
      form: {
        id: { required },
        dosing_at: { required },
        lots: {
          required,
          minLength: minLength(2),
          $each: {
            required
          }
        }
      }
    }
  },
  methods: {

    slugifyId () {
      this.form.id = slugify(this.form.id, { lowercase: false, decamelize: false })
    },

    getFormErrorMessage (field, index) {
      let errors = []

      if (index >= 0) {
        if (!this.$v.form[field].$each.$iter[index].$dirty) return errors
        for (let key in this.$v.form[field].$each.$iter[index].$params) {
          // Add more key here is needed for other type of error messages
          if (key === 'required') !this.$v.form[field].$each.$iter[index].required && errors.push('This field is is required.')
        }
      } else {
        if (!this.$v.form[field].$dirty) return errors
        for (let key in this.$v.form[field].$params) {
          // Add more key here is needed for other type of error messages
          if (key === 'required') !this.$v.form[field].required && errors.push('This field is is required.')
        }
      }

      return errors
    },

    handleClose () {
      this.$emit('on-close-dialog')
    },

    validateFormShipment () {
      console.log(this.$v.basicInfoForm)
      if (this.$v.form.$invalid) {
        this.$v.form.$touch()
      } else {
        this.createBatch()
      }
    },

    assignLotToBatch (id, lots) {
      let promises = []
      lots.forEach((lot) => {
        promises.push(this.$store.dispatch('assignLotToBatch', { batchId: id, lot: lot }))
      })
      Promise.all(promises).then(() => {
        this.$emit('on-close-dialog')
        this.$store.dispatch('showSnackBar', { message: 'Batch created successfully.' })
      }).catch(() => {
        this.submit = false
      })
    },

    createBatch () {
      let formToSend = JSON.parse(JSON.stringify(this.form))
      formToSend.location = this.packagingPlant.id
      formToSend.dosing_at = new Date(formToSend.dosing_at)
      this.submit = true
      this.$store.dispatch('checkBatchId', { id: formToSend.id }).then((res) => {
        if (res === 'exists') {
          this.existDialog = true
          this.assignLotToBatch(formToSend.id, this.form.lots)
        } else {
          this.$store.dispatch('createBatch', { batch: formToSend }).then((batch) => {
            this.assignLotToBatch(batch.id, this.form.lots)
          })
        }
      })
    }
  }
}

</script>

<style lang="scss" scoped>
.farm-shipment-form{
  padding: 5px 7px;
  .title{
    font-weight: 400;
    font-size: 24px !important;
  }
  .padding-top{
    padding-top: 0;
  }
  .btn{
    font-size: 18px;
    font-weight: 500;
  }
}
</style>
